import React from "react";
import PropTypes from "prop-types";

export default function Cell({ innerClassName, className, children }) {
  return (
    <td className={`pb-2 ${className}`}>
      <div
        className={`md:h-[60px] flex items-center md:border-y-0.5 md:border-stone-400 mdpy-4 md:bg-white ${innerClassName}`}
      >
        {children}
      </div>
    </td>
  );
}
Cell.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  innerClassName: PropTypes.string,
};
Cell.defaultProps = {
  className: "",
  innerClassName: "",
};
